import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Typography, TypographyProps } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		...theme.typography.caption,
		fontWeight: 500,
		marginLeft: theme.spacing(1),
		textAlign: 'center',
	},
}));

const AlertDate: React.FC<TypographyProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Typography
			variant="subtitle1"
			className={classNames(classes.root, className)}
			{...props}
		>
			{children}
		</Typography>
	);
};

export default AlertDate;
